import { ViewTypes } from "react-big-scheduler";

// ドメイン名
export const BACKEND_DOMAIN_NAME = 'schedule-backend.ohki.sysdsv.com';
export const FM_DOMAIN_NAME = 'ohki.sysdsv.com';
export const FM_ACCOUNT_NAME = 'ohki';
export const FM_ACCOUNT_PASSWORD = 'OhkiK7155';
export const FM_FILENAME_QUALITY = '品質管理システム'; //CHANGED UPDATE 2023/07/04 #25

// API接続先
let URL = 'http://localhost:8081';
// if (process.env.NODE_ENV === 'production') {
  URL = `https://${BACKEND_DOMAIN_NAME}`;
// }

export const API_URL = URL;

// カレンダー設定
export const SCHEDULER_DATA_CONFIG = {
  schedulerWidth: "100%",
  besidesWidth: 20,
  schedulerMaxHeight: 0,
  tableHeaderHeight: 200,

  // agendaResourceTableWidth: 160,
  // agendaMaxEventWidth: 100,

  // dayResourceTableWidth: 160,
  // weekResourceTableWidth: '16%',
  monthResourceTableWidth: 200,
  // quarterResourceTableWidth: 160,
  // yearResourceTableWidth: 160,
  customResourceTableWidth: 200,

  // dayCellWidth: 30,
  // weekCellWidth: '12%',
  monthCellWidth: 70,
  // quarterCellWidth: 80,
  // yearCellWidth: 80,
  customCellWidth: 70,
  defaultCellWidth: 70,

  // dayMaxEvents: 99,
  // weekMaxEvents: 99,
  monthMaxEvents: 99,
  // quarterMaxEvents: 99,
  // yearMaxEvents: 99,
  customMaxEvents: 99,

  eventItemHeight: 75,
  eventItemLineHeight: 75,
  // nonAgendaSlotMinHeight: 0,
  // dayStartFrom: 0,
  // dayStopTo: 23,
  defaultEventBgColor: "#80C5F6",
  selectedAreaColor: null,
  // nonWorkingTimeHeadColor: '#999999',
  // nonWorkingTimeHeadBgColor: '#fff0f6',
  // nonWorkingTimeBodyBgColor: '#fff0f6',
  // summaryColor: '#666',
  // summaryPos: 1,
  groupOnlySlotColor: "#F8F8F8",

  startResizable: false,
  endResizable: false,
  movable: true,
  creatable: true,
  crossResourceMove: true,
  checkConflict: false,
  scrollToSpecialMomentEnabled: false,
  eventItemPopoverEnabled: false,
  calendarPopoverEnabled: true,
  recurringEventsEnabled: false,
  headerEnabled: false,
  displayWeekend: true,
  relativeMove: true,
  defaultExpanded: true,

  resourceName: "",
  taskName: "タスク名",
  agendaViewHeader: "",
  addMorePopoverHeaderFormat: "YYYY年M月D日 dddd",
  eventItemPopoverDateFormat: "M月D日",
  nonAgendaDayCellHeaderFormat: "HH:mm",
  nonAgendaOtherCellHeaderFormat: "YYYY/MM/DD|ddd",

  // minuteStep: 30,

  views: [
    // {viewName: '日', viewType: ViewTypes.Day, showAgenda: false, isEventPerspective: false},
    // {viewName: '週', viewType: ViewTypes.Week, showAgenda: false, isEventPerspective: false},
    {
      viewName: "月次",
      viewType: ViewTypes.Month,
      showAgenda: false,
      isEventPerspective: false,
    },
    // {viewName: '年', viewType: ViewTypes.Year, showAgenda: false, isEventPerspective: false},
    {
      viewName: "週次",
      viewType: ViewTypes.Custom,
      showAgenda: false,
      isEventPerspective: false,
    },
  ],
};

//CHANGED ADD 2023/07/04 #25
export const FM_CHECKLIST_SHORTCUT = {
  scriptName: "チェックリスト",
};
export const FM_USER_AUTH = {
  ADMIN: 0,
  PRODUCTION: 1,
  GENERAL: 99,
};
